module.exports = __webpack_public_path__ + "img/zjjh_2.baf94aff.png";